var module = angular.module('octopusApp.configuration');

module.controller('TeamIndexController', function($scope, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  isLoading.promise(octopusRepository.Teams.list().then(function (results) {
    $scope.teams = results;
  }));
  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
    $scope.status = status;
  }));
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/controllers/team_index_controller.js
// module id = 405
// module chunks = 1